module.exports = __webpack_public_path__ + "img/HumanBoneStressReactionRange.363772eb.jpg";